<template>
    <div class="form">
        <h4 class="step-title">
            Do you own or rent your home?
        </h4>
        <div class="step-content d-flex flex-column align-items-center step-button-list wider">
            <button-list v-bind:items="ownRent" v-bind:onclick="currentResidenceTypeComplete" v-bind:value="lead.currentResidenceType"/>
        </div>
        <h4 class="step-title">
            Are you interested in Home Owner's Insurance quotes too?
        </h4>
        <div class="step-content d-flex flex-column align-items-center step-button-list wider">
            <yes-no-button-list v-bind:onclick="isInterestedInHomeInsuranceQuotesComplete" v-bind:value="lead.isInterestedInHomeOrRentersInsuranceQuotes"/>
        </div>
    </div>
</template>

<script>
    import ButtonList from "./shared/ButtonList.vue"
    import YesNoButtonList from "./shared/YesNoButtonList.vue"

    export default {
        name: "CurrentResidenceTypeIsInterestedInHomeInsuranceQuotes",
        components: {
            ButtonList,
            YesNoButtonList
        },
        data: function() {
            return {
                ownRent: [
                    { text: "Own", value: "Own" },
                    { text: "Rent", value: "Rent" }
                ]
            }
        },
        props: {
            lead: Object
        },
        methods: {
          currentResidenceTypeComplete: function(value) {
              this.lead.currentResidenceType = value;

              if (value === "Rent") {
                  this.$emit("complete", this.$options.name, value);
              }
          },
          isInterestedInHomeInsuranceQuotesComplete: function(value) {
              this.lead.isInterestedInHomeOrRentersInsuranceQuotes = value;
              this.$emit("complete", this.$options.name, value);
          }
        }
    }
</script>
